import { render } from "./보건의료인(면허발급).vue?vue&type=template&id=7a84b434"
import script from "./보건의료인(면허발급).vue?vue&type=script&lang=js"
export * from "./보건의료인(면허발급).vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__